import Vue from "vue/dist/vue.js";

import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI);

import VueWaypoint from 'vue-waypoint'

import store from './store/store'
import router from './router'
import VueScrollTo from "vue-scrollto"
import App from './app.vue'
import BaseControl from './components/base/base-control.vue'
import BaseDialogModal from './components/base/base-dialog-modal.vue'
import BaseLoadingModal from './components/base/base-loading-modal.vue'
import BaseAlert from './components/base/base-alert.vue'
import BaseTransitionExpand from './components/base/base-transition-expand.vue'
import VModal from 'vue-js-modal'
import DisplayCount from './filters/displaycount'
import vClickOutside from 'v-click-outside'
// import
import {library} from '@fortawesome/fontawesome-svg-core'
import icons from '@fortawesome/fontawesome-pro/js/all'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import Axios from "axios";

import VTooltip from "v-tooltip"
// import setupBugsnagForVue from "../../shared/utils/bugsnag"

if (process.env.NODE_ENV === 'production') {
    Vue.config.devtools = false;
    Vue.config.productionTip = false;
    Vue.config.silent = true;
}

!
// const bugsnagClient = setupBugsnagForVue("ba4f4bc306fb6eabac3c931d61ed269b", "infinity", {appVersion: '1.0.1'});
// store.commit('bugsnagClient', bugsnagClient);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('base-control', BaseControl);
Vue.component('base-dialog-modal', BaseDialogModal);
Vue.component('base-loading-modal', BaseLoadingModal);
Vue.component('base-alert', BaseAlert);
Vue.component('base-transition-expand', BaseTransitionExpand);
// Vue.use()
library.add(icons);

Vue.use(vClickOutside);
Vue.use(VModal);
Vue.use(VueScrollTo);
Vue.prototype.$http = Axios;
Vue.prototype.$httpCancelToken = Axios.CancelToken;
Vue.use(VueWaypoint);
Vue.use(VTooltip);

Vue.filter('displayPrice', (value, asLabel) => {
    return store.state.cart.displayPrice(store.state.cart.formatPrice(value), asLabel);
});
Vue.filter('displayCount', DisplayCount);


if (ab.token) {
    Vue.prototype.$http.interceptors.request.use((config) => {
        if (config.method == "get") {
            if (!config.params) config.params = {};
            config.params.api_token = ab.token
        }
        if (config.method == "post" || config.method == "put" || config.method == "delete") {
            if (!config.data) config.data = {};
            config.data.api_token = ab.token
        }

        return config
    }, function (error) {
        return Promise.reject(error);
    })
}

new Vue({
    el: '#infinityStore',
    router,
    store,
    render: h => h(App)
});
